import FilterAct from './act';
import { defaultInitialValuesResearchFormIcaro } from 'civil-status/constants/default-initial-values-research-form-icaro';
import {
  validationSchemaFilterIcaroAct,
  validationSchemaFilterIcaroPerson,
} from 'civil-status/constants/schema-filter-icaro';
import { ResearchFormIcaro } from 'civil-status/view-models/research-form-icaro';
import { Form, Formik } from 'formik';
import { Fragment, ReactElement, memo } from 'react';
import FilterPerson from './person';

interface FilterIcaroComponentProps {
  openFilterAct?: boolean;
  setOpenFilterAct: (value: boolean) => void;
  openFilterPerson?: boolean;
  setOpenFilterPerson: (value: boolean) => void;
  handleSubmitAct: (values: ResearchFormIcaro) => void;
  handleSubmitPerson: (values: ResearchFormIcaro) => void;
}

const FilterIcaroComponent = ({
  openFilterAct,
  setOpenFilterAct,
  openFilterPerson,
  setOpenFilterPerson,
  handleSubmitAct,
  handleSubmitPerson,
}: FilterIcaroComponentProps): ReactElement => {
  return (
    <Fragment>
      <Formik
        initialValues={defaultInitialValuesResearchFormIcaro}
        onSubmit={handleSubmitAct}
        validateOnMount
        validationSchema={validationSchemaFilterIcaroAct}
      >
        <Form>
          <FilterAct open={openFilterAct} setOpen={setOpenFilterAct} />
        </Form>
      </Formik>
      <Formik
        initialValues={defaultInitialValuesResearchFormIcaro}
        onSubmit={handleSubmitPerson}
        validateOnMount
        validationSchema={validationSchemaFilterIcaroPerson}
      >
        <Form>
          <FilterPerson open={openFilterPerson} setOpen={setOpenFilterPerson} />
        </Form>
      </Formik>
    </Fragment>
  );
};

FilterIcaroComponent.displayName = 'Filter Icaro Page component';

const FilterIcaro = memo(FilterIcaroComponent);

export default FilterIcaro;
